import { render } from "./ETutoring.vue?vue&type=template&id=050d4edc&scoped=true"
import script from "./ETutoring.vue?vue&type=script&lang=js"
export * from "./ETutoring.vue?vue&type=script&lang=js"

import "./ETutoring.vue?vue&type=style&index=0&id=050d4edc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050d4edc"]])

export default __exports__